module.exports = __webpack_public_path__ + "images/emoji/ear.175251decef14aa0213f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ear.png
// module id = Ee9B
// module chunks = 14